import { render, staticRenderFns } from "./UserEnrollments.vue?vue&type=template&id=2e10349e&scoped=true"
import script from "./UserEnrollments.vue?vue&type=script&lang=js"
export * from "./UserEnrollments.vue?vue&type=script&lang=js"
import style0 from "./UserEnrollments.vue?vue&type=style&index=0&id=2e10349e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e10349e",
  null
  
)

export default component.exports